<template>
  <div class="top-bar-cla">
    <div class="chart-title">{{ title }}</div>
    <el-select v-model="currentValue" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentValue: '',
      options: [
        {
          value: 7,
          label: this.$t('statistics.lastSevenDays')
        },
        {
          value: 30,
          label: this.$t('statistics.lastMonth')
        },
        {
          value: 90,
          label: this.$t('statistics.lastThreeMonths')
        }
      ]
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        this.currentValue = newValue
      },
      immediate: true
    },
    currentValue: {
      handler(newValue, oldValue) {
        this.$emit('input', newValue)
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="less">
.top-bar-cla {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 12px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/modules/statistics/apiStatistics/chartTop.vue